import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";

const CalanderEditIconSVG = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const predefinedSizes = {
    small: { ...themeValue?.fontSmlSize?.size },
    medium: { ...themeValue?.fontMediumSize?.size },
    large: { ...themeValue?.fontLgSize?.size },
  };
  const { size, width, height } = props;
  const finalSize = predefinedSizes[size] || { width, height };
  return (
    <svg
      width={finalSize.width || "57"}
      height={finalSize.height || "56"}
      viewBox="0 0 57 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.8333 12.9167C18.1527 12.9167 17.5833 12.3473 17.5833 11.6667V4.66675C17.5833 3.98622 18.1527 3.41675 18.8333 3.41675C19.5138 3.41675 20.0833 3.98622 20.0833 4.66675V11.6667C20.0833 12.3473 19.5138 12.9167 18.8333 12.9167Z"
        fill="currentColor"
        stroke="currentColor"
      />
      <path
        d="M37.5 12.9167C36.8195 12.9167 36.25 12.3473 36.25 11.6667V4.66675C36.25 3.98622 36.8195 3.41675 37.5 3.41675C38.1805 3.41675 38.75 3.98622 38.75 4.66675V11.6667C38.75 12.3473 38.1805 12.9167 37.5 12.9167Z"
        fill="currentColor"
        stroke="currentColor"
      />
      <path
        d="M19.3056 33.1851L19.3057 33.1849L19.2928 33.1799C19.0683 33.0936 18.8896 32.9735 18.693 32.7985C18.363 32.4431 18.1666 31.964 18.1666 31.4999C18.1666 31.0359 18.3629 30.5569 18.6928 30.2015C18.8815 30.0345 19.0854 29.9065 19.3056 29.8148C19.7425 29.6327 20.2574 29.6327 20.6943 29.8148C20.9097 29.9045 21.1095 30.029 21.2948 30.1907C21.3255 30.2277 21.3588 30.2661 21.3865 30.2981C21.4011 30.3149 21.4141 30.33 21.4244 30.3421C21.471 30.397 21.4951 30.4293 21.5078 30.4505L21.514 30.4607L21.5206 30.4706C21.5927 30.5788 21.6415 30.6791 21.6723 30.7714L21.6836 30.8051L21.6994 30.8369C21.7484 30.9349 21.7779 31.0257 21.7926 31.1104C21.8169 31.2805 21.8333 31.4039 21.8333 31.4999C21.8333 31.9639 21.637 32.4429 21.3071 32.7983C21.1184 32.9654 20.9145 33.0934 20.6943 33.1851L20.8866 33.6466L20.6943 33.1851C20.4655 33.2804 20.2275 33.3333 20 33.3333C19.7724 33.3333 19.5344 33.2804 19.3056 33.1851Z"
        fill="currentColor"
        stroke="currentColor"
      />
      <path
        d="M28.1666 33.8333C27.8633 33.8333 27.5599 33.7633 27.2799 33.6466C26.9766 33.53 26.7433 33.3666 26.5099 33.1566C26.0899 32.7133 25.8333 32.1066 25.8333 31.4999C25.8333 31.3599 25.8566 31.1966 25.8799 31.0333C25.9032 30.8933 25.9499 30.7533 26.0199 30.6133C26.0666 30.4733 26.1366 30.3333 26.23 30.1933C26.3233 30.0766 26.4166 29.96 26.5099 29.8433C27.3733 28.98 28.9366 28.98 29.8232 29.8433C29.9166 29.96 30.0099 30.0766 30.1032 30.1933C30.1966 30.3333 30.2666 30.4733 30.3133 30.6133C30.3833 30.7533 30.4299 30.8933 30.4533 31.0333C30.4766 31.1966 30.4999 31.3599 30.4999 31.4999C30.4999 32.1066 30.2432 32.7133 29.8232 33.1566C29.3799 33.5766 28.7966 33.8333 28.1666 33.8333Z"
        fill="currentColor"
      />
      <path
        d="M20 42C19.6966 42 19.3933 41.93 19.1133 41.8134C18.8333 41.6967 18.5766 41.5333 18.3433 41.3233C17.9233 40.88 17.6666 40.2733 17.6666 39.6667C17.6666 39.5267 17.6899 39.3633 17.7133 39.2233C17.7366 39.06 17.7833 38.92 17.8533 38.78C17.8999 38.64 17.97 38.5 18.0633 38.36C18.1333 38.2433 18.25 38.1267 18.3433 38.01C18.5766 37.8 18.8333 37.6366 19.1133 37.52C19.6733 37.2866 20.3266 37.2866 20.8866 37.52C21.1666 37.6366 21.4233 37.8 21.6566 38.01C21.7499 38.1267 21.8666 38.2433 21.9366 38.36C22.0299 38.5 22.1 38.64 22.1467 38.78C22.2167 38.92 22.2633 39.06 22.2867 39.2233C22.31 39.3633 22.3333 39.5267 22.3333 39.6667C22.3333 40.2733 22.0766 40.88 21.6566 41.3233C21.4233 41.5333 21.1666 41.6967 20.8866 41.8134C20.6066 41.93 20.3033 42 20 42Z"
        fill="currentColor"
      />
      <path
        d="M47.9999 22.96H8.33325C7.37659 22.96 6.58325 22.1666 6.58325 21.21C6.58325 20.2533 7.37659 19.46 8.33325 19.46H47.9999C48.9566 19.46 49.7499 20.2533 49.7499 21.21C49.7499 22.1666 48.9566 22.96 47.9999 22.96Z"
        fill="currentColor"
      />
      <path
        d="M37.0801 53.1533C36.1935 53.1533 35.3535 52.8266 34.7468 52.2199C34.0235 51.4966 33.6968 50.4466 33.8601 49.3499L34.3035 46.1999C34.4201 45.3832 34.9102 44.4033 35.4935 43.8199L43.7534 35.5599C44.8734 34.4399 45.9702 33.8566 47.1602 33.7399C48.6302 33.5999 50.0534 34.2066 51.4068 35.5599C52.8301 36.9832 54.7434 39.8766 51.4068 43.2132L43.1468 51.4732C42.5635 52.0566 41.5834 52.5466 40.7668 52.6633L37.6168 53.1066C37.4301 53.1299 37.2668 53.1533 37.0801 53.1533ZM47.5568 37.2166C47.5334 37.2166 47.5101 37.2166 47.4868 37.2166C47.1601 37.24 46.7168 37.5432 46.2268 38.0332L37.9668 46.2932C37.8968 46.3632 37.7801 46.5966 37.7801 46.6899L37.3601 49.6066L40.2768 49.1866C40.3701 49.1632 40.6034 49.0466 40.6734 48.9766L48.9334 40.7166C49.9601 39.69 50.1001 39.1766 48.9334 38.0099C48.5601 37.6599 48.0234 37.2166 47.5568 37.2166Z"
        fill="currentColor"
      />
      <path
        d="M48.9802 44.9164C48.8169 44.9164 48.6535 44.8931 48.5135 44.8464C45.4335 43.9831 42.9836 41.5331 42.1202 38.4531C41.8636 37.5198 42.4002 36.5631 43.3335 36.2831C44.2669 36.0264 45.2235 36.5631 45.5035 37.4964C46.0402 39.4098 47.5569 40.9264 49.4702 41.4631C50.4035 41.7197 50.9402 42.6998 50.6835 43.6331C50.4502 44.4031 49.7502 44.9164 48.9802 44.9164Z"
        fill="currentColor"
      />
      <path
        d="M28.1666 53.0834H18.8333C10.3166 53.0834 5.41663 48.1834 5.41663 39.6667V19.8334C5.41663 11.3167 10.3166 6.41675 18.8333 6.41675H37.5C46.0166 6.41675 50.9166 11.3167 50.9166 19.8334V28.0001C50.9166 28.9567 50.1233 29.7501 49.1666 29.7501C48.21 29.7501 47.4166 28.9567 47.4166 28.0001V19.8334C47.4166 13.1601 44.1733 9.91675 37.5 9.91675H18.8333C12.16 9.91675 8.91663 13.1601 8.91663 19.8334V39.6667C8.91663 46.3401 12.16 49.5834 18.8333 49.5834H28.1666C29.1233 49.5834 29.9166 50.3767 29.9166 51.3334C29.9166 52.2901 29.1233 53.0834 28.1666 53.0834Z"
        fill="currentColor"
      />
    </svg>
  );
};
const CalanderEditIcon = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const { size, color } = props;
  const predefinedSizes = {
    small: themeDefault?.info?.newConfig?.fontSmlSize,
    medium: themeDefault?.info?.newConfig?.fontMediumSize,
    large: themeDefault?.info?.newConfig?.fontLgSize,
  };

  return (
    <Icon
      component={CalanderEditIconSVG}
      style={{
        fontSize: predefinedSizes[size] || predefinedSizes.medium,
      }}
      {...props}
    />
  );
};

export default CalanderEditIcon;
